import { Device } from '~/Store/Devices'
import { Delete } from './Delete'
import { Get } from './Get'
import { ApiHelpers, APIHosts } from './ApiHelpers'
export interface Filter {
  filter?: string
  expand?: string
  entitySetName?: string
  paging?: boolean
  orderBy?: string
  page?: number
  pageSize?: number
  offset?: number
  take?: number
  total?: number
  userName?: string
  deviceName?: string
  devicePlatform?: string
}

export interface DataResponse {
  results: Device[]
  page: number
  pageCount: number
  pageSize: number
  queryCount: number
  firstRowIndex: number
  lastRowIndex: number
}

export interface DeactivateDeviceData {
  userId: string
  mac: string
  clientID: string
}
class DevicesServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  public getDevices(data?: Filter) {
    const baseUrl = this.getHost(this.ApiHost);
    const url = `${baseUrl}/Devices`;
    const filterData = { params: { ...data } };
    return Get(url, filterData);
  }

  public deactivateDevices = (data: DeactivateDeviceData[]) => {
    const baseUrl = this.getHost(this.ApiHost);
    return Delete(`${baseUrl}/Devices/deactive/user`, data);
  }
}

export const DevicesService = new DevicesServiceController()
